import { createPosString, getSpan, generateGridPlaceholders } from 'utils/section/gridUtils';
import type { TemplateFormsState } from '../index';
import type { TemplateSection, TemplateSectionItem } from 'types/helios/templateForms/templateForms';
import { initialItem as initialItemSource } from './addNewSection';

const initialItem = initialItemSource as TemplateSectionItem;

export const copyWebToMobile = (state: TemplateFormsState) => {
  const webSections = state.Web.sections;

  const mobileSections: TemplateSection[] = webSections.map((section) => {
    const validItems = section.items.filter((item) => !!item.itemGuid);

    let currentY = 0;
    const positionedItems: TemplateSectionItem[] = validItems.map((item) => {
      const spanY = getSpan(item.y);
      const newY = createPosString(currentY, spanY);

      const newItem: TemplateSectionItem = {
        ...item,
        x: '0',
        y: newY,
        subTabId: null,
      };

      currentY += spanY;
      return newItem;
    });

    const newSizeX = 1;
    const newSizeY = currentY > 0 ? currentY : 1;

    const filledItems = generateGridPlaceholders(positionedItems, newSizeX, newSizeY, initialItem, []);

    return {
      ...section,
      sizeX: newSizeX,
      sizeY: newSizeY,
      items: filledItems,
      subTabs: null,
    };
  });

  state.Mobile.sections = mobileSections;
  state.Mobile.tabs = state.Web.tabs.map((tab) => ({ ...tab }));
};
